<template>
  <div class="container-fluid py-4">
    <!-- Header type consultation -->
    <div class="d-flex justify-content-between align-items-center mb-4 header-clinique flex-wrap">
      <div class="d-flex align-items-center gap-3">
        <i class="bi bi-file-medical fs-2 text-primary"></i>
        <h2 class="fw-bold mb-0">Types de consultations</h2>
      </div>
       <button
      class="btn btn-outline-primary btn-lg shadow-sm"
      @click="imprimerTypesConsultations"
    >
      <i class="bi bi-printer me-2"></i> Imprimer
    </button>
      <button class="btn btn-primary btn-lg shadow-sm btn-clinique mt-2 mt-md-0" @click="creation">
        <i class="bi bi-plus-circle me-2"></i> Création
      </button>
    </div>

    <!-- Card filtrage et tableau -->
    <div class="card p-3 p-md-4 shadow-sm rounded card-clinique">
      <!-- Filtres -->
      <div class="row mb-3 g-3 justify-content-end">
        <div class="col-12 col-md-3">
          <input v-model="searchQuery" class="form-control form-control-clinique" placeholder="Rechercher..." />
        </div>
        <div class="col-6 col-md-2">
          <select v-model="itemsperpage" class="form-select form-select-clinique">
            <option v-for="item in itemsPerPageT" :key="item" :value="item">{{ item }}</option>
          </select>
        </div>
        <div class="col-6 col-md-3">
          <select v-model="orderBy" class="form-select form-select-clinique">
            <option v-for="(value, key) in orderByTabs" :key="key" :value="value">{{ key }}</option>
          </select>
        </div>
        <div class="col-6 col-md-2">
          <select v-model="sortOrder" class="form-select form-select-clinique">
            <option v-for="(value, key) in sortOrders" :key="key" :value="value">{{ key }}</option>
          </select>
        </div>
      </div>

      <!-- Tableau -->
      <div class="table-responsive overflow-auto">
        <table class="table table-hover table-bordered align-middle text-center w-100">
          <thead class="table-primary">
            <tr>
              <th>#</th>
              <th>Nom</th>
              <th class="d-none d-sm-table-cell">Prix</th>
              <th class="d-none d-md-table-cell">Description</th>
              <th>Statut</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(type, index) in filteredTypes" :key="type.id">
              <td>{{ index + 1 + (currentPage - 1) * itemsperpage }}</td>
              <td>{{ type.nom }}</td>
              <td class="d-none d-sm-table-cell">{{ type.prix }}</td>
              <td class="d-none d-md-table-cell">{{ type.description || '—' }}</td>
              <td>
                <span :class="type.isEnabled ? 'text-success' : 'text-danger'">
                  {{ type.isEnabled ? 'Activé' : 'Désactivé' }}
                </span>
              </td>
              <td>
                <div class="dropdown text-center">
                  <button
                    class="btn btn-sm btn-outline-primary dropdown-toggle"
                    type="button"
                    data-bs-toggle="dropdown"
                  >
                    ⋮
                  </button>
                  <ul class="dropdown-menu">
                    <li><a class="dropdown-item" @click="modifier(type.id)">Modifier</a></li>
                    <li><a class="dropdown-item text-danger" @click="supprimer(type.id)">Supprimer</a></li>
                  </ul>
                </div>
              </td>
            </tr>
            <tr v-if="typeConsultations.length === 0">
              <td colspan="6" class="text-center">Aucune donnée disponible</td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Pagination -->
      <nav>
        <ul class="pagination justify-content-end flex-wrap">
          <li class="page-item" :class="{ disabled: currentPage === 1 }">
            <button class="page-link" @click="changePage(currentPage - 1)">Précédent</button>
          </li>
          <li
            v-for="page in totalPages"
            :key="page"
            class="page-item"
            :class="{ active: page === currentPage }"
          >
            <button class="page-link" @click="changePage(page)">{{ page }}</button>
          </li>
          <li class="page-item" :class="{ disabled: currentPage === totalPages }">
            <button class="page-link" @click="changePage(currentPage + 1)">Suivant</button>
          </li>
        </ul>
      </nav>
    </div>
  </div>
</template>

<script>
import api from '@/api';

export default {
  data() {
    return {
      searchQuery: '',
      itemsperpage: 50,
      orderBy: 'tc.nom',
      sortOrder: 'asc',
      typeConsultations: [],
      totalItems: 0,
      currentPage: 1,
      itemsPerPageT: [50, 100, 150,200],
      orderByTabs: {
        Nom: 'tc.nom',
        Prix: 'tc.prix',
        Description: 'tc.description',
      },
      sortOrders: {
        Croissant: 'asc',
        Décroissant: 'desc',
      },
       systeme: null,
    isLoadingSysteme: false,
    };
  },
  computed: {
    totalPages() {
      return Math.ceil(this.totalItems / this.itemsperpage);
    },
    filteredTypes() {
      if (!this.searchQuery) return this.typeConsultations;
      return this.typeConsultations.filter(t =>
        t.nom.toLowerCase().includes(this.searchQuery.toLowerCase())
      );
    }
  },
  methods: {
    async getTypes() {
      try {
        const res = await api.getItems('type_consultations', {
          page: this.currentPage,
          itemsperpage: this.itemsperpage,
          orderBy: this.orderBy,
          sortOrder: this.sortOrder,
          search: this.searchQuery
        });
        this.typeConsultations = res.data.data;
        this.totalItems = res.data.meta?.total_records || 0;
      } catch (err) {
        console.error('Erreur de chargement des types consultations :', err);
      }
    },
    changePage(page) {
      this.currentPage = page;
      this.getTypes();
    },
    async loadSysteme() {
  this.isLoadingSysteme = true;
  try {
    const res = await api.getItems('configurations');

    //  prendre le premier élément du tableau
    this.systeme = res.data?.data?.[0] || null;

  } catch (e) {
    console.error("Erreur chargement système", e);
  } finally {
    this.isLoadingSysteme = false;
  }
}
,
    creation() {
      this.$router.push({ name: 'create_type_consultation' });
    },
    modifier(id) {
      this.$router.push({ name: 'edit_type_consultation', params: { id } });
    },
    async changerStatus(type) {
      try {
        await api.patchItem('type_consultations', type.id, { isEnabled: !type.isEnabled });
        this.getTypes();
      } catch (err) {
        alert('Erreur lors du changement de statut');
      }
    },
    async supprimer(id) {
      if (confirm('Voulez-vous supprimer ce type de consultation ?')) {
        await api.deleteItem('type_consultations', id);
        this.getTypes();
      }
    },
    imprimerTypesConsultations() {

  const types = this.typeConsultations; 
  if (!types || !types.length) return;

  const config = this.systeme || {};
  const baseURL = process.env.VUE_APP_API_BASE_URL || "http://127.0.0.1:8000";

  const logoUrl = config.logo
    ? (config.logo.startsWith("http") ? config.logo : `${baseURL}${config.logo}`)
    : "";

  const printWindow = window.open("", "_blank");

  const html = `
<!DOCTYPE html>
<html>
<head>
<title>Liste des Types de Consultations</title>

<style>

@page { size: A4; margin: 2cm; }

body {
  font-family: Arial, sans-serif;
  font-size: 14px;
  margin:0;
}

header {
  text-align:center;
  border-bottom: 2px solid #0056b3;
  padding-bottom:10px;
  margin-bottom:20px;
}

header h1 {
  margin:0;
  color:#0056b3;
}

header p {
  margin:2px 0;
  font-size:13px;
}

h3 {
  text-align:center;
  color:#0056b3;
  margin:20px 0;
  text-decoration:underline;
}

table {
  width:100%;
  border-collapse: collapse;
}

th, td {
  border:1px solid #0056b3;
  padding:8px;
  font-size:13px;
}

th {
  background-color:#e6f0ff;
  text-align:center;
}

td {
  text-align:center;
}

footer {
  margin-top:20px;
  border-top:1px solid #0056b3;
  padding-top:5px;
  font-size:12px;
  text-align:center;
}

</style>

</head>

<body>

<header>
  ${logoUrl ? `<img src="${logoUrl}" style="width:80px;height:80px;object-fit:contain;">` : ""}
  <h1>${config.nom || "CLINIQUE MÉDICALE"}</h1>
  <p>${config.adresse || ""}</p>
  <p>Tél : ${config.telephone || ""}</p>
</header>

<h3>Liste des Types de Consultations</h3>

<table>

<thead>
<tr>
<th>#</th>
<th>Nom</th>
<th>Prix</th>
<th>Description</th>
<th>Statut</th>
</tr>
</thead>

<tbody>

${types.map((t, i) => `
<tr>
<td>${i + 1}</td>
<td>${t.nom}</td>
<td>${t.prix ? t.prix.toLocaleString() + " FCFA" : "-"}</td>
<td>${t.description || "-"}</td>
<td>${t.isEnabled ? "Activé" : "Désactivé"}</td>
</tr>
`).join("")}

</tbody>

</table>

<footer>
© ${new Date().getFullYear()} ${config.nom || "Clinique Médicale"}
</footer>

</body>
</html>
`;

  printWindow.document.write(html);
  printWindow.document.close();

  printWindow.onload = () => {
    printWindow.focus();
    printWindow.print();
    printWindow.close();
  };

}
  },
  watch: {
    searchQuery() {
      this.currentPage = 1;
      this.getTypes();
    },
    itemsperpage() {
      this.currentPage = 1;
      this.getTypes();
    },
    orderBy() {
      this.getTypes();
    },
    sortOrder() {
      this.getTypes();
    }
  },
  created() {
    this.getTypes();
    this.loadSysteme();
  }
};
</script>

<style scoped>
.header-clinique {
  padding: 15px 20px;
  background-color: #e9f5ff;
  border-radius: 12px;
  margin-bottom: 20px;
}

.card-clinique {
  background: #f8fafd;
  border-radius: 12px;
  border: none;
}

.form-control-clinique,
.form-select-clinique {
  border-radius: 10px;
  border: 1px solid #d1e3f0;
  padding: 10px 14px;
  transition: all 0.3s ease;
}
.form-control-clinique:focus,
.form-select-clinique:focus {
  box-shadow: 0 0 6px #0d6efd33;
  border-color: #0d6efd;
}

.btn-clinique {
  background: linear-gradient(90deg, #0d6efd, #6610f2);
  border: none;
  color: #fff;
  border-radius: 10px;
  transition: all 0.3s ease;
}
.btn-clinique:hover {
  box-shadow: 0 5px 15px rgba(0,0,0,0.2);
  transform: translateY(-2px);
}

.table th,
.table td {
  vertical-align: middle;
}

.pagination .page-item .page-link {
  color: #007bff;
}
.pagination .page-item.active .page-link {
  background-color: #007bff;
  border-color: #007bff;
  color: white;
}

/* Responsive adjustments */
@media (max-width: 767px) {
  .table td,
  .table th {
    padding: 0.4rem 0.5rem;
    font-size: 0.85rem;
  }

  .btn-clinique {
    width: 100%;
  }

  .header-clinique {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }
}
</style>
